<h2 mat-dialog-title style="text-align: center">
  Soll der Auftrag wirklich abgeschlossen werden ?
</h2>
<mat-dialog-content class="mat-typography">
  <div style="height: 0.5rem"></div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout"
  style="justify-content: space-between"
>
  <button mat-button (click)="doCancel()">Nein</button>
  <button mat-button style="margin-left: 1rem" (click)="doClose()">Ja</button>
</div>
